<template>
	<div class="content-wrapper">
		<div class="sf-flex-column">
			<!-- 조회부분 시작 -->
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<pc-grnt-ct-search ref="search" :scrId="scrId"></pc-grnt-ct-search>
				</sf-card>
			</div>
			<!-- 조회부분 끝 -->

			<!-- 그리드 부분 시작 -->
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<pc-grnt-ct-table ref="table" @Refresh="Refresh" :scrId="scrId"></pc-grnt-ct-table>
				</sf-card>
			</div>
			<!-- 그리드 부분 시작 -->
		</div>
	</div>
</template>

<script>
import PcGrntCtSearch from './Search/PcGrntCtSearch.vue';
import PcGrntCtTable from './Table/PcGrntCtTable.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	created() {
		console.clear();
	},
	components: { PcGrntCtSearch, PcGrntCtTable },
	methods: {
		Refresh() {
			this.$refs.search.searchList();
		}
	}
};
</script>

<style></style>
